import styled from '@emotion/styled';
export const EmphasisContainer = styled.span `
  background-color: rgba(0, 0, 0, 0.3);
  padding: 2px 8px;
  border-radius: 10px;
  display: inline-block;
  margin: 1px;
  line-height: 1em;
`;
